// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-edit-checkpoint-menu .mat-mdc-menu-trigger .mat-icon {
  height: 100%;
  font-size: 14px;
}
.fi-checklist-edit-checkpoint-menu .mat-icon {
  color: var(--fi-color-dark);
}

.fi-checklist-edit-checkpoint-menu-panel {
  max-width: unset;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/edit/checkpoint-menu/checkpoint-menu.component.scss"],"names":[],"mappings":"AAEQ;EACI,YAAA;EACA,eAAA;AADZ;AAII;EACI,2BAAA;AAFR;;AAMA;EACI,gBAAA;AAHJ","sourcesContent":[".fi-checklist-edit-checkpoint-menu {\r\n    .mat-mdc-menu-trigger {\r\n        .mat-icon {\r\n            height: 100%;\r\n            font-size: 14px;\r\n        }\r\n    }\r\n    .mat-icon {\r\n        color: var(--fi-color-dark);\r\n    }\r\n}\r\n\r\n.fi-checklist-edit-checkpoint-menu-panel {\r\n    max-width: unset;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
